import { render, staticRenderFns } from "./NumberSquare.vue?vue&type=template&id=69cb5db8&"
import script from "./NumberSquare.vue?vue&type=script&lang=js&"
export * from "./NumberSquare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports